import React from 'react';
import { CheckCircle, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const ThankYou: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <CheckCircle size={64} className="text-emerald-500 mx-auto mb-6" />
        <h1 className="text-3xl font-black text-slate-900 mb-4">
          ¡Gracias por contactarnos!
        </h1>
        <p className="text-slate-600 mb-8">
          Hemos recibido tu mensaje. Te contactaremos en menos de 24 horas.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-emerald-500 text-white font-bold rounded-xl hover:bg-emerald-600 transition-colors"
        >
          <ArrowLeft size={18} />
          Volver al inicio
        </Link>
      </div>
    </div>
  );
};
